export default __webpack_public_path__ + "static/capital-notes-3ed6ba1da363a5f978f77dea6e8cd065.jpg";